import http from "../../utils/httpClient";

class productVariantService {
  createProductVariant = async (data) => {
    return await http.post("/api/ProductVariant/CreateProductVariant", data);
  };

  deleteProductVariant = async (id) => {
    return await http.delete("/api/ProductVariant/" + id);
  };

  getProductVariant = async () => {
    return await http.get("/api/ProductVariant/GetProductVariant?getAll=Y");
  };

  getProductVariantById = async (searchBy) => {
    return await http.get("/api/ProductVariant/GetProductVariant" + searchBy);
  };

  getProductVariantByCategoryId = async (id) => {
    return await http.get(
      "/api/ProductVariant/GetVariantWithOptionByCategoryId?CategoryId=" + id,
    );
  };
}

export default new productVariantService();
